"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const dotGet = function dotGet(object, path) {
    if (path === '')
        return object;
    const pathParts = path.split('.');
    const first = pathParts.shift();
    const remainingPath = pathParts.join('.');
    const levelObject = object.type;
    if (first === '$' || /^[0-9]+$/.test(first)) {
        return dotGet({ type: levelObject[0] }, remainingPath);
    }
    else if ((0, isPlainObject_1.default)(levelObject[first])) {
        return dotGet(levelObject[first], remainingPath);
    }
    if (levelObject === 'blackbox') {
        return { type: 'blackbox', optional: true, isBlackboxChild: true };
    }
    return null;
};
function default_1(schema, path) {
    if ((0, isNil_1.default)(schema)) {
        throw new Error('You need to pass a schema');
    }
    return dotGet({ type: schema }, path);
}
exports.default = default_1;
